<template>
  <section>
    <div class="usercontainer clearfix">
      <div class="container">
        <div class="user-hd pinjiatype title">发表评价</div>
        <div class="user-cont flex ju-ar">
          <div class="order-item">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="clearfix cpinfo">
                      <a href="#/goodsdetail">
                        <div class="img">
                          <img :src="commentItem.indexpic" />
                        </div>
                        <div class="cont">
                          <div class="name ellipsis-2">{{commentItem.title}}</div>
                          <div class="desc">{{commentItem.specnames}}</div>
                        </div>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="num_text">
            <div class="row">
              <div class="fieldname title blod">评分：</div>
              <div class="cont">
                <el-rate v-model="star" show-text></el-rate>
              </div>
            </div>
            <div class="row">
              <div class="fieldname title pinjiatype">评价内容：</div>
              <div class="cont">
                <textarea class="form-control" rows="4" v-model="content " style="width: 300px;"></textarea>
              </div>
               <el-switch v-model="ishide" active-text="匿名" inactive-text="不匿名"></el-switch>
            </div>
          </div>
          <div class="row title" style="width:500px;">
            <div class="cont center">
              <el-upload
                multiple
                :limit="limit"
                :action="uploadimg"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-change="filechange"
                :on-remove="handleRemove"
                :on-exceed="exceed"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" size="tiny">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </div>
          </div>
          
        </div>
       
        <div class="formbox">
          <div class="row">
            <div class="fieldname"></div>
            <div class="cont center">
              <el-button type="primary" @click="submitpinjia" class="mb20">提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pinjia",
  data() {
    return {
      limit: 6,
      star: 5,
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      content: "",
      ishide: true,
      dialogImageUrl: "",
      fileList: [],
      orderDetail: {},
      dialogVisible: false
    };
  },
  props: {
    commentItem: {
      type: Object,
      default: {}
    }
  },
  methods: {
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(this.dialogImageUrl)
    },
    filechange(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    exceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}张图片！`);
    },
    async submitpinjia() {
      let photos = this.fileList.map(item => {
        if (item.response.code == 0) return item.response.msg;
      });
      let data = {
        star: this.star,
        content: this.content,
        photos,
        detailid: this.commentItem.id,
        type: 1,ishide:this.ishide?1:0,
        orderno: this.commentItem.orderno
      };
      console.log(data);
      let res = await this.$fetch("member/addcomment", {
        body: data
      });
      if (res) {
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.$router.push("/usercenter?type=1-1");
      }
    }
    // 封装获取数据的方法
    // async getOrderDetail() {
    //   console.log(this.orderno);
    //   let data = getParameterByName();
    //   let url = data.jifen ? "member/ordergiftlist" : "Member/orderdetail";
    //   let res = await this.$fetch(url, {
    //     body: {
    //       orderno: data.orderno
    //     }
    //   });
    //   console.log(res);
    //   res.shipfee = parseFloat(res.shipfee);
    //   res.amount = parseFloat(res.amount);

    //   this.orderDetail = res;
    // }
  },
  mounted() {
    // this.getOrderDetail();
  }
};
</script>

<style lang='scss' scoped>
.user-cont {
  align-items: flex-start;
}
.container {
  background: #fff;
  padding-top: 20px;
}
.row {
  margin: 20px 0;
}

.cont {
  padding: 10px 0;
  .el-rate__item {
    i {
      font-size: 30px;
    }
  }
}
.num_text {
  display: flex;
  width: 300px;
  flex-direction: column;
  justify-content: space-around;
  .row {
    margin: 0;
  }
}
.img {
  width: 200px;
  height: 200px;
  // a {
  //   display: inline-block;
  //   width: 100%;
  //   height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/pingjia.vue